import React from 'react';
import MarketingNav from './MarketingNav';

function ContactHero() {
  return (
    <header className="hero hero--compact" id="top">
      <div className="wrap">
        <MarketingNav activeLink="contact" />
        <div className="hero-inner">
          <div className="eyebrow" style={{ color: 'var(--cream)' }}>
            Contact
          </div>
          <h1>
            Let&apos;s keep your
            <br />
            pipeline <em>warm.</em>
          </h1>
          <p className="lede">
            Questions about Nurturer, pricing, or want to see it on your own pipeline? Send a note — a
            real person replies within one business day.
          </p>
        </div>
      </div>
    </header>
  );
}

export default ContactHero;
